import { FlashcardEmbedContent } from '@apps/flashcard';
import { usePM2DisplayContext } from '@pm2/store';
import { jsx } from 'react/jsx-runtime';

function FlashcardEmbed(props) {
  const {
    inLightbox
  } = usePM2DisplayContext();
  return /*#__PURE__*/jsx(FlashcardEmbedContent, {
    entryKey: props.component.entryKey,
    title: props.component.envelope.Title,
    data: props.component.data,
    onCollapse: props.onCollapse,
    node: props.node,
    context: inLightbox ? "lightbox" : "embedded",
    onResetEntry: props.onResetEntry
  });
}

export { FlashcardEmbed };
//# sourceMappingURL=comp.embed.js.map
